import { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { NotificationContext, UserContext } from '../App';
import Frame from '../layout/Frame';
import { Button, Input, Popup } from '../components';
import { AppRoute, ButtonType, InputType } from '../types/enums';
import { loginByCredentials } from '../utils/auth';
import { isValidEmail } from '../utils/common';

import lockIcon from '../components/Input/lock-solid.svg';
import mailIcon from '../components/Input/envelope-regular.svg';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const Login = () => {
  const notify = useContext(NotificationContext);
  const { setUser } = useContext(UserContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<{ email?: boolean; password?: boolean }>({});

  const onLogin = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY, { action: 'login' })
        .then((token: string) => {
          loginByCredentials(token, email, password, setUser, notify);
        });
    });
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const err = {
      email: !isValidEmail(email),
      password: !password
    };

    setErrors(err);

    if (!Object.values(err).some((val) => val)) {
      onLogin();
    }
  };

  return (
    <Frame>
      <Popup show title="LOGIN" permanent>
        <div>
          <p>To enter the administration area please login.</p>
          <form onSubmit={onSubmit}>
            <Input
              id="email"
              label="E-mail:"
              value={email}
              setValue={setEmail}
              placeholder="youremail@gmail.com"
              icon={mailIcon}
              error={errors.email ? 'Error: The field is required' : ''}
            />
            <Input
              id="password"
              label="Password:"
              value={password}
              setValue={setPassword}
              placeholder="your password"
              icon={lockIcon}
              type={InputType.PASSWORD}
              error={errors.password ? 'Error: The field is required' : ''}
            />
            <Button type={ButtonType.PRIMARY} fullWidth isSubmit>
              Login
            </Button>
            <p>
              <strong>
                Don't have an account?&nbsp;
                <NavLink className="color-orange" to={AppRoute.REGISTER}>
                  Sign up here!
                </NavLink>
              </strong>
            </p>
            <p>
              <NavLink className="color-orange" to={AppRoute.FORGOT_PASSWORD} state={{ email }}>
                Forgot your password?
              </NavLink>
            </p>
          </form>
        </div>
      </Popup>
    </Frame>
  );
};

export default Login;
